// TASK-005 / BUG-2026-0170: Generate sample columns with unit-aware Depth headers.
// The Metric/Imperial toggle is LABEL-ONLY: depth values are stored and shown
// exactly as entered — the toggle only changes the unit shown in the table
// headers (m/ft). No ×3.28084 conversion anywhere (BUG-2026-0170: 60 must
// stay 60 when switching units, not become 196.8).
import { sampleColumns } from './sampleColumns';
import type { GridColumn } from '../../components/tables/EditableGrid';

export type DepthUnit = 'm' | 'ft';

/**
 * Depth display passthrough. Kept as a named seam (and for call-site
 * stability) but deliberately unit-agnostic: the stored number IS the
 * displayed number regardless of the toggle.
 */
export function toDisplayDepth(value: unknown, _unit: DepthUnit): number | string | null {
  if (value === null || value === undefined || value === '') return value as any;
  const n = Number(value);
  if (isNaN(n)) return value as any;
  return n;
}

/**
 * Normalize an edited depth cell for storage. No unit conversion — the
 * number the user typed is the number that gets stored.
 */
export function toStoredDepth(value: unknown, _unit: DepthUnit): number | null {
  if (value === null || value === undefined || value === '') return null;
  const n = Number(value);
  if (isNaN(n)) return null;
  return n;
}

/** @deprecated alias kept for older call sites — same passthrough as toStoredDepth. */
export const toMeters = toStoredDepth;

export function sampleColumnsForUnit(unit: DepthUnit): GridColumn[] {
  return sampleColumns.map((c) => {
    if (c.field === 'DepthTop') return { ...c, headerName: `Depth Top (${unit})` };
    if (c.field === 'DepthBase') return { ...c, headerName: `Depth Base (${unit})` };
    return c;
  });
}
